import React, { useState, forwardRef } from 'react';
import { Radio } from '../radio';
import { List, ListItem } from './styled';
const RadioGroup = forwardRef(function RadioGroup({ options, labels, disabled, name = 'radioGroup', selected = '', ...rest }, ref) {
    const [checked, setChecked] = useState(selected);
    const radioList = options.map((option, index) => (React.createElement(ListItem, { key: index },
        React.createElement(Radio, { checked: checked === option, disabled: disabled === option, label: labels[index], name: name, onChange: (e) => setChecked(e.target.value), value: option }))));
    return options ? (React.createElement(List, { ref: ref, ...rest }, radioList)) : null;
});
export default RadioGroup;
